// mindzera-frontend/src/How.jsx
import BrainImage from './assets/brain-transparent.png';
import HowBanner from './components/HowBanner.jsx';

export default function How() {
  return (
    <main className="max-w-4xl mx-auto px-4 sm:px-8 md:px-16 text-center">
      <section className="pt-8 pb-6 relative flex flex-col items-center">
        {/* Glowing background circle */}
        <div className="absolute top-6 w-64 h-64 rounded-full bg-blue-600 opacity-40 blur-2xl animate-pulse z-0" />

        {/* Foreground brain image */}
        <img
          src={BrainImage}
          alt="Stylized brain"
          className="w-48 md:w-60 relative z-10 mb-4"
        />

        {/* Cycling banner text */}
        <HowBanner />
      </section>
    </main>
  );
}
